<template>
  <div id="trace-report">
    <Carousel
      class="report-carousel"
      autoplay
      :autoplay-speed="autoplaySpeed"
      v-model="value"
      :loop="getReport.length > 1 ? true : false ">
      <CarouselItem class="report-item" v-for="(item, index) in getReport" :key="index">
        <img class="report-img" :src="item" />
      </CarouselItem>
    </Carousel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "trace-report",
  data() {
    return {
      value: 0,
      autoplaySpeed: 3000
    };
	},
	computed: {
		...mapGetters("trace", ["getReport"])
	}
};
</script>

<style scoped>
#trace-report {
  position: relative;
  width: 100%;
  height:  100%;
  overflow: hidden;
}

.report-carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.report-item {
  max-width: 100%;
  max-height: 100%;
}

.report-img {
  display: block;
  max-width: 70%;
  max-height: 70%;
  margin: 0 auto;
}
</style>
